import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {LoadingBar} from "../../../components/Loader";
import Pagination from "../../../components/Pagination";

import Aqp from "../../../../libs/mk-react-aqp";
import createLink from "../../../../libs/createLink";
import ArticleGrid from "../../../components/ArticleGrid";
import {fetchArticles, resetArticles} from "../../../../creators/articles";
import {fetchArticlesTag, resetArticlesTag} from "../../../../creators/articles.tag";
import {Button} from "../../../components/Button";
import {canonical} from "../../../../libs/helper";
import Helmet from "react-helmet";


class Articles extends React.Component {
    constructor(props) {
        super(props);
        this.props.resetArticlesTag();
        this.props.resetArticles();
        this.filter = {
            limit: (this.props.slugUser && !this.props.showAll) ? 15 : 30,
            sort: 0,
            page: 1,
            tags : this.props.tag._id
        };
        if(this.props.slugUser && !this.props.showAll){
            this.filter = {
                ...this.filter,
                "owner.slug!" : this.props.slugUser
            }
        }
        if(this.props.slugUser && this.props.showAll){
            this.filter = {
                ...this.filter,
                "owner.slug" : this.props.slugUser
            }
        }
        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page'],
            currentLink: createLink("tagArticle", {tag : this.props.tag, slug : this.props.slugUser, showAll : this.props.showAll}),
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        if(this.props.slugUser && !this.props.showAll){
            this.getArticlesTag({
                ...this.state.filter,
                limit : 9,
                page : 1,
                "owner.slug" : this.props.slugUser
            });
        }
        this.getArticles(this.state.filter);

    }


    getArticlesTag(filter) {
        let query = {...filter};
        this.props.fetchArticlesTag(query);
    }

    getArticles(filter) {
        let query = {...filter};
        this.props.fetchArticles(this.aqp.set(query));
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getArticles(filter);
        window.scrollTo(0, 0);
    }

    render() {
        let totalPage = this.props.articles ? Math.ceil(this.props.articlesTotal / this.state.filter.limit) : 0;
        let url = createLink("tagArticle", {tag : this.props.tag, showAll :true});
        let currentPage = parseInt(this.state.filter.page);
        return (
            <div className="container">
                <div className={"big column"}>
                    <Helmet>
                        <title>{(this.props.tag && this.props.tag.infos && this.props.tag.infos.story && this.props.tag.infos.story.title) || this.props.metaHelmet().title }</title>
                        <meta name="description" content={(this.props.tag && this.props.tag.infos && this.props.tag.infos.story && this.props.tag.infos.story.description) || this.props.metaHelmet().description } />
                        <meta name="robots" content="noindex" />
                        {currentPage === 2 && (<link rel="prev" href={canonical(url, "", "article")}/>)}
                        {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${url}/${(currentPage - 1)}`, "", "article")}`} />)}
                        <link rel="canonical" href={currentPage >1 ? `${canonical(`${url}/${currentPage}`, "", "article")}` : canonical(url)} />
                        {totalPage >0 && currentPage < totalPage && (<link rel="next" href={`${canonical(`${url}/${(currentPage + 1)}`, "", "article")}`} />)}
                    </Helmet>
                    {this.props.articlesLoading && (
                        <LoadingBar />
                    )}
                    {this.props.articlesTagTotal !== 0 && this.props.slugUser && (
                        <h3 className={"w-100 flex-jc-sb"}>
                            Contenu de : {this.props.articlesTag && this.props.articlesTag[0] && this.props.articlesTag[0].owner && this.props.articlesTag[0].owner.username}
                            <Button to={this.aqp.queryUrl(this.state.filter).link+"/all"}
                                    className={"mr-8 primary small"}
                                    size={"small"}
                                    btnStyle={"primary"}
                                    content={"Voir tout"}
                            />
                        </h3>
                    )}
                    {this.props.articlesTagInitialized && !this.props.articlesTagLoading && (
                        this.props.articlesTagTotal > 0 ? (
                            <ArticleGrid handleUserId={this.handleUserId}
                                         isStory={false}
                                         articles={this.props.articlesTag}
                                         userStories={false}
                                         removeHtml={true}/>
                        ) : (
                            this.props.articlesTotal >0 && (<div className={"no-content"}>Aucun article correspondante à votre recherche</div>)
                        ))
                    }

                    {this.props.articlesTagTotal !== 0 && this.props.slugUser && (
                        <h4 className={"w-100 mt-24"}>Découvrez d'autres articles de Voissanautes avec le tag "{this.props.tag && this.props.tag.title}"</h4>
                    )}
                    {this.props.articlesInitialized && !this.props.articlesLoading && (
                        this.props.articlesTotal > 0 ? (
                            <ArticleGrid handleUserId={this.handleUserId}
                                         isStory={false}
                                         articles={this.props.articles}
                                         userStories={false}
                                         removeHtml={true}/>
                        ) : (
                            <div className={"no-content"}>Aucun article correspondante à votre recherche</div>
                        )
                    )}

                    {totalPage > 1 && (
                        <Pagination
                            currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            {...this.aqp.queryUrl(this.state.filter)}
                            handleChangePage={this.handleChangePage}
                        />
                    )}
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        articles: state.articles.data,
        articlesLoading: state.articles.loading,
        articlesInitialized: state.articles.initialized,
        articlesTotal: state.articles.total,

        articlesTag: state.articlesTag.data,
        articlesTagLoading: state.articlesTag.loading,
        articlesTagInitialized: state.articlesTag.initialized,
        articlesTagTotal: state.articlesTag.total,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchArticles,
    fetchArticlesTag,
    resetArticlesTag,
    resetArticles
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Articles);
